import * as React from 'react';

import { AsyncBoundary } from '@rematter/ui-web';
import { LucideAlertTriangle } from 'lucide-react';

import { useGenerateSemaphorToken } from '../hooks/useGenerateSemaphorToken';
import { useTranslations } from '../i18n/useTranslations';

import { runtimeConfig } from '~/config/runtime';

export const ReportsView: React.FC = () => {
  const t = useTranslations();
  const { data, loading, error } = useGenerateSemaphorToken();

  const token = data?.integrationsSemaphorGenerateToken?.accessToken;
  const embedUrl = token
    ? `${runtimeConfig.semaphor.embedUrl}/${token}?showAssistant=true&showControls=true&currentTheme=light`
    : null;

  return (
    <AsyncBoundary loading={loading} error={error} className="@ReportsView">
      {embedUrl ? (
        <div className="@ReportsView h-full w-full">
          <iframe
            src={embedUrl}
            className="h-full w-full border-0"
            title={t.reports.dashboard.title}
            allow="clipboard-write"
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
          />
        </div>
      ) : (
        <div className="@ReportsView flex h-full items-center justify-center p-8">
          <div className="w-full max-w-md text-center">
            <div className="mb-4 flex justify-center">
              <div className="flex size-12 items-center justify-center rounded-full bg-warning/10">
                <LucideAlertTriangle className="size-6 text-warning" />
              </div>
            </div>
            <h2 className="mb-2 text-lg font-semibold text-neutral/80">
              {t.reports.errors.noAccessToken}
            </h2>
            <p className="text-sm text-neutral/60">
              {t.reports.errors.tokenUnavailable}
            </p>
          </div>
        </div>
      )}
    </AsyncBoundary>
  );
};
